<template>
  <b-form-group :label="label" label-class="text-truncate">
    <b-form-select
        class="large-bootstrap-select"
        :options="tagsOptions(tags)"
        :multiple="multiple"
        plain
        :disabled="disabled"
        ref="select"
        :value="value"
        @input="$emit('input', $event)"
    />
  </b-form-group>
</template>

<script>
export default {
  props: ['fieldName', 'tags', 'value', 'tagIdProp', 'tagValueProp', 'selectPickerOptions', 'multiple', 'disabled'],
  computed: {
    label() {
      if (this.fieldName) {
        return this.fieldName.toUpperCase()
      } else {
        return null
      }
    }
  },
  methods: {
    tagsOptions(tags) {
      const idProp = this.tagIdProp || 'id';
      const valProp = this.tagValueProp || 'name';

      return tags.map(tag => {
        return {
          value: tag[idProp],
          text: tag[valProp]
        }
      })
    },

    refreshSelect() {
      this.$nextTick(() => {
        $(this.$refs.select.$el).selectpicker('refresh');
      });
    }
  },

  watch: {
    tags(val) {
      this.refreshSelect()
    },

    value(val) {
      this.refreshSelect()
    }
  },

  mounted() {
    const options = {
      style: 'btn-outline p-2',
      ...this.selectPickerOptions,
    };
    $(this.$refs.select.$el).selectpicker(options);
  },
}
</script>